import { useEffect, useState, useRef } from 'react';

interface ElementPickerOverlayProps {
  isActive: boolean;
}

export function ElementPickerOverlay({ isActive }: ElementPickerOverlayProps) {
  const [highlightStyle, setHighlightStyle] = useState<React.CSSProperties>({
    display: 'none'
  });
  const targetRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!isActive) {
      setHighlightStyle({ display: 'none' });
      return;
    }

    const updateHighlight = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      if (!target || target === document.body || target === document.documentElement) {
        setHighlightStyle({ display: 'none' });
        return;
      }

      targetRef.current = target;
      const rect = target.getBoundingClientRect();
      
      setHighlightStyle({
        position: 'fixed',
        left: `${rect.left}px`,
        top: `${rect.top}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        border: '2px solid #e74c3c',
        borderRadius: '4px',
        boxShadow: '0 0 0 4px rgba(231, 76, 60, 0.3)',
        pointerEvents: 'none',
        zIndex: 9999,
        transition: 'all 0.05s ease-out',
        display: 'block'
      });
    };

    const handleClick = (e: MouseEvent) => {
      if (targetRef.current) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener('mousemove', updateHighlight);
    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('mousemove', updateHighlight);
      document.removeEventListener('click', handleClick, true);
    };
  }, [isActive]);

  return (
    <div style={highlightStyle}>
      <div
        style={{
          position: 'absolute',
          top: '-24px',
          left: '0',
          background: '#e74c3c',
          color: '#fff',
          padding: '2px 6px',
          borderRadius: '3px',
          fontSize: '10px',
          fontFamily: 'monospace',
          whiteSpace: 'nowrap'
        }}
      >
        Нажми для выбора
      </div>
    </div>
  );
}